// Function index:
//   makeRow()          — empty <div class="party-row"> element.
//   metaLine(text)     — <div class="party-meta"> with text.
//   esc(s)             — HTML-escape a string for innerHTML interpolation.

export function makeRow(): HTMLDivElement {
  const row = document.createElement('div');
  row.className = 'party-row';
  return row;
}

export function metaLine(text: string): HTMLDivElement {
  const el = document.createElement('div');
  el.className = 'party-meta';
  el.textContent = text;
  return el;
}

export function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
